export default __webpack_public_path__ + "static/media/25.132d6d94.jpg";